import { ARSTActionSetSidebarFilter, ArsTableState } from "../interface";

/**
 * Updates the current sidebar filter value.
 *
 * @param state - Current ARS table state
 * @param action - Sidebar filter update action
 * @returns Updated ARS table state
 */
export const arst_setSidebarFilter = <T>(
  state: ArsTableState<T>,
  action: ARSTActionSetSidebarFilter,
): ArsTableState<T> => ({
  ...state,
  settings: {
    ...state.settings,
    currentSidebar: {
      ...state.settings.currentSidebar,
      filter: action.filter,
    },
  },
});
